@if (profile$ | async; as profile) {
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 text-center kyc-modal">
      <img [src]="'/assets/images/success.svg'" [alt]="'success_alt_text' | translate" />
      <span class="font-size-32 font-semibold mb-20">{{
        "fma_kyc_thanks_title" | translate: [profile.forename]
      }}</span>
      @if (!isInfoEdited) {
        <span class="font-size-17 kyc-modal-headline">{{
          "fma_kyc_thanks_text" | translate
        }}</span>
      }
      @if (forceKycFlow && isInfoEdited) {
        <span class="font-size-17 kyc-modal-headline">{{
          "kyc_confirmation_changes_forced" | translate
        }}</span>
      }
      @if (!forceKycFlow && isInfoEdited) {
        <div>
          <div class="font-size-17 kyc-modal-confirmation">{{ "kyc_confirmation_changes_1" | translate }}</div>
          <div class="font-size-17 kyc-modal-headline">{{ "kyc_confirmation_changes_2" | translate }}</div>
        </div>
      }
    </div>
  </div>
}
